import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { bootstrap } from './app/bootstrap';
import { RuntimeProvider } from './app/runtime';
import './index.css';

// Асинхронный (SDK, транспорт, сессия), но не блокирует первый рендер: статус
// соединения App берёт из стора и обновится сам, когда бутстрапу будет что сказать.
// RuntimeProvider дожидается этого же промиса, чтобы отдать экранам RestClient —
// вызывается bootstrap() ровно один раз, здесь.
const runtime = bootstrap();
runtime.catch((err: unknown) => {
  // Бутстрап не должен падать молча: без этого разработчик увидит только
  // «идёт подключение» навсегда и не поймёт, что оно никогда не наступит.
  console.error('bootstrap failed', err);
});

const container = document.getElementById('root');
if (!container) throw new Error('#root не найден в index.html');

createRoot(container).render(
  <StrictMode>
    <RuntimeProvider runtime={runtime}>
      <App />
    </RuntimeProvider>
  </StrictMode>,
);
